import { apiService } from '@/service/api'

/**
 * Every `frontend`-tier feature flag for this person, evaluated by the web tier's one evaluator
 * (this replaces evaluating flags in the browser with posthog-js). Values are booleans, or a
 * variant string for a variant flag.
 * Endpoint: GET /v2/me/flags
 */
export async function getMyFlags(): Promise<{ flags: Record<string, boolean | string> }> {
  const response = await apiService.fetchOrError(apiService.getUrl('v2/me/flags'))
  return response.json()
}
